import { render } from "./weOffert.vue?vue&type=template&id=11291cf4"
const script = {}

import "./weOffert.vue?vue&type=style&index=0&id=11291cf4&lang=css"

import exportComponent from "X:\\Proyecto\\riego-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__